module.exports = __webpack_public_path__ + "img/4_02.04bd2c88.png";